<template>
  <van-row justify="center" class="page-wrapper">
    <van-col
      span="24"
      class="itserve-center round-shadow-btn flex-display-fix container_width mt-15"
      style="align-items: center"
    >
      <info-message class="apply-loader flex-display-fix write-ticket-message"
        >{{ $t("writeTicket.ticketInfo") }}
      </info-message>
    </van-col>
    <van-col
      span="24"
      class="itserve-center flex-display-fix"
      style="align-items: center"
    >
      <!--      <itserve-route-->
      <!--        route-name="FAQ"-->
      <!--        :buttonName="$t('buttons.faq')"-->
      <!--        type="wide"-->
      <!--        class="less-tall-btn mb-25 mt-25"-->
      <!--      ></itserve-route>-->
      <!--      <itserve-route-->
      <!--        route-name="AppSupport"-->
      <!--        :buttonName="$t('buttons.appTechSupport')"-->
      <!--        :params="{-->
      <!--          // support: 'energy_support_kh',-->
      <!--          account: $route.params.account,-->
      <!--        }"-->
      <!--        type="wide"-->
      <!--        class="less-tall-btn mb-25"-->
      <!--      ></itserve-route>-->
      <!--      <itserve-route-->
      <!--        route-name="AppSupport"-->
      <!--        :buttonName="$t('buttons.appEnergoSbytSupport')"-->
      <!--        :params="{-->
      <!--          support: 'sales_support_kh',-->
      <!--          account: $route.params.account,-->
      <!--        }"-->
      <!--        type="wide"-->
      <!--        class="less-tall-btn mb-25"-->
      <!--      ></itserve-route>-->
      <div class="itserve-center flex-display-fix centered-content">
        <itserve-button
          @click="makeACall(phone)"
          :value="$t('buttons.calToOblEnergo')"
          type="primary"
          class="pay-button apply-loader"
          small="font-size: 14px"
        ></itserve-button>
        <itserve-button
          @click="goToContacts"
          :value="$t('components.supportBottomMenu.contacts')"
          type="primary"
          class="pay-button apply-loader"
          small="font-size: 14px"
        ></itserve-button>
      </div>
    </van-col>
  </van-row>
</template>
<script>
import ItserveButton from "@/components/forms/ItserveButton";
//import ItserveRoute from "@/components/content/ItserveRoute";
import InfoMessage from "@/components/content/InfoMessage";
import "vue-awesome/icons/phone";
import "vue-awesome/icons/comments";
export default {
  name: "WriteTicket",
  data() {
    return {
      phone: process.env.VUE_APP_CALL_PHONE,
    };
  },
  components: { InfoMessage, ItserveButton },
  methods: {
    makeACall(number) {
      this.nativeSendEvent("tel", { number });
    },
    goToContacts() {
      this.$router.push({ name: "Contacts" });
    },
  },
};
</script>
<style>
.write-ticket-message .info-content {
  text-align: center;
}
.write-ticket-message {
  width: 100%;
}
.centered-content,
.centered-content h5 {
  align-items: center;
  text-align: center;
}
</style>
